import { useEffect, useRef, useState } from "react";
import Dropdown from "../Dropdown";
import { XMarkIcon } from "@heroicons/react/24/outline";

export const FilterItem = (props) => {
  const [position, setPosition] = useState("right");
  const lastAutoOpenRef = useRef(false);

  function handleRemove(e) {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    props.remove();
  }

  const triggerRef = useRef(null);

  // Deterministically auto-open the dropdown by clicking the trigger element.
  // This bypasses any timing quirks in the Dropdown's internal `defaultOpen` logic.
  useEffect(() => {
    const shouldOpen = !!props.defaultOpen;
    const wasOpenRequested = lastAutoOpenRef.current;
    lastAutoOpenRef.current = shouldOpen;

    if (!shouldOpen || wasOpenRequested) return;

    const t = setTimeout(() => {
      // Click the inner trigger; the event will bubble to the MenuButton wrapper.
      triggerRef.current?.dispatchEvent(
        new MouseEvent("click", { bubbles: true, cancelable: true })
      );
    }, 0);

    return () => clearTimeout(t);
  }, [props.defaultOpen]);

  const handleClick = (e) => {
    const divWidth = triggerRef.current.getBoundingClientRect().width;
    const halfDivWidth = divWidth / 2;
    const mouseXPos = e.nativeEvent.offsetX;

    if (mouseXPos <= halfDivWidth) {
      // setPosition("left");
    } else {
      setPosition("right");
    }
  };

  return (
    <div className="flex items-center border rounded-lg py-1 pl-2 pr-1 space-x-1 text-xs bg-white">
      <Dropdown
        id="test"
        className="!w-max"
        dataWrapperClassName="w-max"
        modal={false}
        // Keep passing this for backwards compatibility with other callers,
        // but auto-open is handled above via trigger click.
        defaultOpen={!!props.defaultOpen}
        align={position}
        data={props.dropdown}
        trigger={
          <div
            ref={triggerRef}
            onClick={handleClick}
            className="flex items-center space-x-1 cursor-pointer"
          >
            <span className="text-gray-600">{props.title}:</span>
            <span className="font-semibold">
              {props.displayText || props.value}
            </span>
          </div>
        }
      />
      <button
        type="button"
        aria-label={`Remove ${props.title} filter`}
        onPointerDown={(e) => {
          // Headless UI MenuButton toggles on pointer events; block before they fire.
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={handleRemove}
        className="inline-flex items-center justify-center rounded p-0.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  );
};
